module.exports = __webpack_public_path__ + "assets/img/address_empty.74e209d6.png";